/**
 * This is a blank page for testing ui components without outliers & skips loading screen
 * @copyright 2021-2025 Soter Technologies, LLC. All rights reserved.
 * @file blankpage.js
 * @author Kyle Watkins, Paul Scala
 */

import React from 'react'

const BlankPage = ({theme = "Dark"}) => {
    React.useLayoutEffect(() => {
        document.body.classList.add(theme)
    }, [])
    return null
}

export default BlankPage
